import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/index";

Vue.use(Router);

export const RouterMap = [
  {
    path: "/",
    name: "index",
    component: Index,
    redirect: "/Home",
    children: [
      {
        path: "Home",
        name: "Home",
        meta: {
          title: "54741234热线平台"
        },
        component: () => import("@/views/Home/index.vue")
      },
      {
        path: "Evaluate",
        name: "Evaluate",
        component: () => import("@/views/Evaluate/index.vue")
      },
      {
        path: "AnnouncementList",
        name: "AnnouncementList",
        component: () => import("@/views/AnnouncementList/index.vue")
      },
      {
        path: "SelectEvaluateType",
        name: "SelectEvaluateType",
        component: () => import("@/views/Evaluate/SelectEvaluateType.vue")
      },
      {
        path: "CasualPatting",
        name: "CasualPatting",
        component: () => import("@/views/CasualPatting/RouterView.vue"),
        redirect: "/CasualPatting/index",
        children: [
          {
            path: "index",
            name: "CasualPattingIndex",
            component: () => import("@/views/CasualPatting/index.vue")
          },
          {
            path: "GetLocation",
            name: "GetLocation",
            component: () => import("@/views/CasualPatting/GetLocation.vue")
          }
        ]
      },
      {
        path: "YouthVoice",
        name: "YouthVoice",
        component: () => import("@/views/YouthVoice/RouterView.vue"),
        redirect: "/YouthVoice/index",
        children: [
          {
            path: "index",
            name: "YouthVoice",
            component: () => import("@/views/YouthVoice/index.vue")
          },
          {
            path: "GetLocation",
            name: "GetLocation",
            component: () => import("@/views/YouthVoice/GetLocation.vue")
          }
        ]
      },
      {
        path: "Gradute",
        name: "Gradute",
        component: () => import("@/views/Gradute/RouterView.vue"),
        redirect: "/Gradute/index",
        children: [
          {
            path: "index",
            name: "Gradute",
            component: () => import("@/views/Gradute/index.vue")
          },
          {
            path: "GetLocation",
            name: "GetLocation",
            component: () => import("@/views/Gradute/GetLocation.vue")
          }
        ]
      },
      {
        path: "HistoryFeedback",
        name: "HistoryFeedback",
        component: () => import("@/views/RouterView/index.vue"),
        redirect: "/HistoryFeedback/index",
        children: [
          {
            path: "index",
            name: "HistoryFeedbackIndex",
            component: () => import("@/views/HistoryFeedback/index.vue")
          },
          {
            path: "Feedback",
            name: "Feedback",
            component: () => import("@/views/Feedback/index.vue")
          }
        ]
      },
      {
        path: "Article",
        name: "Article",
        component: () => import("@/views/Article/index.vue")
      },
      {
        path: "Phone",
        name: "Phone",
        component: () => import("@/views/Phone/index.vue")
      },
      {
        path: "removeAccessToken",
        name: "removeAccessToken",
        component: () => import("@/views/removeAccessToken/index.vue")
      },
      {
        path: "ServiceDisclosure",
        name: "ServiceDisclosure",
        component: () => import("@/views/ServiceDisclosure/index.vue")
      },
      {
        path: "serviceDetail",
        name: "serviceDetail",
        component: () => import("@/views/ServiceDisclosure/serviceDetail.vue")
      },
      {
        path: "dataDisclosure",
        name: "dataDisclosure",
        component: () => import("@/views/dataDisclosure/index.vue")
      },
      {
        path: "Online",
        name: "Online",
        component: () => import("@/views/Online/index.vue")
      },
      {
        path: "Building",
        name: "Building",
        component: () => import("@/views/Building/index.vue")
      },
      {
        path: "LostFind",
        name: "LostFind",
        component: () => import("@/views/LostFind/index.vue")
      },
      {
        path: "findInfo",
        name: "findInfo",
        component: () => import("@/views/LostFind/findInfo.vue")
      },
      {
        path: "lostInfo",
        name: "lostInfo",
        component: () => import("@/views/LostFind/lostInfo.vue")
      },
      {
        path: "searchLostFind",
        name: "searchLostFind",
        component: () => import("@/views/LostFind/searchLostFind.vue")
      },
      {
        path: "myList",
        name: "myList",
        component: () => import("@/views/LostFind/myList.vue")
      },
      {
        path: "addLost",
        name: "addLost",
        component: () => import("@/views/LostFind/addLost.vue")
      },
      {
        path: "addFind",
        name: "addFind",
        component: () => import("@/views/LostFind/addFind.vue")
      },
      {
        path: "reconmend",
        name: "reconmend",
        component: () => import("@/views/LostFind/reconmend.vue")
      },
      {
        path: "guideFind",
        name: "guideFind",
        component: () => import("@/views/LostFind/guideFind.vue")
      },
      {
        path: "Dean",
        name: "Dean",
        component: () => import("@/views/Dean/index.vue")
      },
      {
        path: "SearchDetail",
        name: "SearchDetail",
        component: () => import("@/views/Dean/SearchDetail.vue")
      },
      {
        path: "Qusetion",
        name: "Qusetion",
        component: () => import("@/views/Dean/Qusetion.vue")
      },
      {
        path: "guideLost",
        name: "guideLost",
        component: () => import("@/views/LostFind/guideLost.vue")
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: __dirname,
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: RouterMap
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;

// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js